/* Illusione enhancements - loads after theme.js, does not modify it.
   1) Product gallery: finger swipe (scroll-snap) + thumb sync + prev/next arrows
   2) Home hero: touch swipe; category strip: native scroll + arrows
   3) Collection page: infinite (continuous) pagination */
(function () {
  "use strict";

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* 1) Product gallery swipe + arrows */
  function initProductGallerySwipe() {
    var detail = qs("[data-product-detail]");
    if (!detail) return;
    var track = qs("[data-product-gallery-track]", detail);
    if (!track) return;
    var slides = qsa("[data-gallery-slide]", track);
    var thumbs = qsa(".gallery-thumb", detail);
    if (!slides.length) return;

    var activeIndex = 0;

    function setActive(idx) {
      activeIndex = Number(idx) || 0;
      thumbs.forEach(function (t) {
        var on = String(t.getAttribute("data-gallery-index")) === String(idx);
        t.classList.toggle("border-black", on);
        t.classList.toggle("border-transparent", !on);
      });
    }

    function scrollToIndex(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx > slides.length - 1) idx = 0;
      var s = slides[idx];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft, behavior: "smooth" });
      setActive(idx);
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        scrollToIndex(Number(btn.getAttribute("data-gallery-index") || 0));
      });
    });

    /* Prev/Next arrows (only when more than one image) */
    if (slides.length > 1) {
      var host = track.parentNode;
      if (host && !qs("[data-gallery-arrow]", host)) {
        try {
          if (window.getComputedStyle && window.getComputedStyle(host).position === "static") {
            host.style.position = "relative";
          }
        } catch (e) {}
        var mkArrow = function (dir, label, pathD) {
          var b = document.createElement("button");
          b.type = "button";
          b.setAttribute("aria-label", label);
          b.setAttribute("data-gallery-arrow", dir);
          b.style.cssText =
            "position:absolute;top:50%;transform:translateY(-50%);z-index:5;" +
            (dir === "next" ? "right:12px;" : "left:12px;") +
            "width:40px;height:40px;border-radius:9999px;background:rgba(255,255,255,0.92);" +
            "box-shadow:0 2px 10px rgba(0,0,0,0.15);border:none;cursor:pointer;" +
            "display:flex;align-items:center;justify-content:center;color:#0F0F0F;" +
            "-webkit-tap-highlight-color:transparent;transition:background .2s;";
          b.addEventListener("mouseenter", function () { b.style.background = "#ffffff"; });
          b.addEventListener("mouseleave", function () { b.style.background = "rgba(255,255,255,0.92)"; });
          b.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + pathD + "</svg>";
          b.addEventListener("click", function (e) {
            e.preventDefault();
            scrollToIndex(activeIndex + (dir === "next" ? 1 : -1));
          });
          return b;
        };
        host.appendChild(mkArrow("prev", "\u00d6nceki g\u00f6rsel", '<path d="m15 18-6-6 6-6"></path>'));
        host.appendChild(mkArrow("next", "Sonraki g\u00f6rsel", '<path d="m9 18 6-6-6-6"></path>'));
      }
    }

    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        setActive(best);
      });
    }, { passive: true });

    setActive(0);
  }

  /* shared swipe helper */
  function attachSwipe(el, onSwipe) {
    if (!el) return;
    var x0 = null, y0 = null, t0 = 0;
    el.addEventListener("touchstart", function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    el.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0, dt = Date.now() - t0;
      x0 = null; y0 = null;
      if (dt > 800) return;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
      onSwipe(dx > 0 ? 1 : -1);
    }, { passive: true });
  }

  /* 2a) Hero banner swipe — handled in sections/hero.liquid (data-img-hero) */
  function initHeroSwipe() {
    /* no-op: hero section owns drag/swipe */
  }

  /* 2b) Category strip: native horizontal scroll + arrow buttons */
  function initCategoryScroll() {
    var viewport = qs("[data-category-scroll]");
    if (!viewport) return;
    var root = viewport.closest ? viewport.closest("[data-home-category-native]") : null;
    if (!root) root = document;
    var prev = qs("[data-category-prev]", root);
    var next = qs("[data-category-next]", root);
    function step(dir) {
      var amount = Math.max(220, Math.round(viewport.clientWidth * 0.8));
      viewport.scrollBy({ left: dir * amount, behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); step(1); });
  }

  /* 3) Collection infinite scroll */
  function syncWishHearts(scope) {
    var favs = [];
    try { favs = JSON.parse(localStorage.getItem("illusione_favorites") || "[]"); } catch (e) {}
    if (!Array.isArray(favs)) favs = [];
    qsa("[data-card-wish]", scope).forEach(function (btn) {
      var id = String(btn.getAttribute("data-product-id") || "");
      var on = id && favs.indexOf(id) !== -1;
      var svg = btn.querySelector("svg");
      if (svg) svg.setAttribute("fill", on ? "#e11d48" : "none");
    });
  }

  function initCollectionInfiniteScroll() {
    var grid = qs("[data-collection-product-grid]");
    if (!grid) return;
    var pagination = qs(".collection-page__pagination");
    var nextLink = pagination ? qs(".next a", pagination) : null;
    if (!nextLink) return;
    var nextUrl = nextLink.getAttribute("href");
    if (pagination) pagination.style.display = "none";

    var loading = false, done = false;

    var loader = document.createElement("div");
    loader.setAttribute("data-infinite-loader", "");
    loader.style.cssText = "grid-column:1/-1;text-align:center;padding:28px 0;font-size:11px;letter-spacing:0.14em;color:#9ca3af;text-transform:uppercase;display:none;";
    loader.textContent = "Yukleniyor...";
    grid.appendChild(loader);

    var sentinel = document.createElement("div");
    sentinel.style.cssText = "width:100%;height:1px;";
    if (pagination && pagination.parentNode) pagination.parentNode.insertBefore(sentinel, pagination);
    else if (grid.parentNode) grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    function loadNext() {
      if (loading || done || !nextUrl) return;
      loading = true;
      loader.style.display = "";
      fetch(nextUrl, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("page"); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var newGrid = doc.querySelector("[data-collection-product-grid]");
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (c) {
              if (c.hasAttribute && c.hasAttribute("data-infinite-loader")) return;
              grid.insertBefore(document.importNode(c, true), loader);
            });
          }
          var nn = doc.querySelector(".collection-page__pagination .next a");
          nextUrl = nn ? nn.getAttribute("href") : null;
          if (!nextUrl) done = true;
          syncWishHearts(grid);
          loading = false;
          loader.style.display = "none";
          window.requestAnimationFrame(check);
        })
        .catch(function () {
          loading = false; done = true;
          loader.style.display = "none";
          if (pagination) pagination.style.display = "";
        });
    }

    function check() {
      if (done || loading) return;
      var rect = sentinel.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top <= vh + 700) loadNext();
    }

    if (typeof IntersectionObserver !== "undefined") {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) loadNext(); });
      }, { rootMargin: "700px 0px" });
      io.observe(sentinel);
    } else {
      window.addEventListener("scroll", check, { passive: true });
    }
    check();
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    initProductGallerySwipe();
    initHeroSwipe();
    initCategoryScroll();
    initCollectionInfiniteScroll();
  });
})();
